import { Check } from "lucide-react";

export interface StepperStage {
  label: string;
  date?: string;
  state: "done" | "current" | "pending";
}

/**
 * DS-CMP-004 — data-driven multi-stage stepper (FR-CST-003/007). State always reflects the real
 * status/fulfillment fields (FLOW-DET pattern) — never a fixed illustrative sequence. Current
 * stage is conveyed by more than color (bold text + a filled ring), for accessibility.
 */
export function Stepper({ stages }: { stages: StepperStage[] }) {
  return (
    <div className="flex items-start w-full overflow-x-auto py-1.5">
      {stages.map((stage, i) => (
        <div key={stage.label} className="flex flex-col items-center flex-1 min-w-[96px] relative">
          {i > 0 && (
            <div
              className={`absolute top-4 right-1/2 w-full h-0.5 ${stage.state !== "pending" ? "bg-status-green" : "bg-border"}`}
              style={{ zIndex: 0 }}
            />
          )}
          <div
            className={`w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm z-10 border-2 ${
              stage.state === "done"
                ? "bg-status-green border-status-green text-white"
                : stage.state === "current"
                  ? "bg-brand-blue border-brand-blue text-white shadow-[0_0_0_5px_rgba(47,111,237,.15)]"
                  : "bg-surface border-border text-ink-muted"
            }`}
          >
            {stage.state === "done" ? <Check size={15} /> : ""}
          </div>
          <div className={`text-[10.5px] font-bold mt-2 text-center ${stage.state === "pending" ? "text-ink-muted" : "text-ink"}`}>
            {stage.label}
          </div>
          {stage.date && <div className="text-[10px] text-ink-muted mt-0.5 text-center">{stage.date}</div>}
        </div>
      ))}
    </div>
  );
}
